import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BookingState {
  filters: {
    search: string;
    status: string;
  };
  selectedBookingId: string | null;
  isModalOpen: boolean;
}

const initialState: BookingState = {
  filters: { search: '', status: 'all' },
  selectedBookingId: null,
  isModalOpen: false,
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<BookingState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setSelectedBookingId: (state, action: PayloadAction<string | null>) => {
      state.selectedBookingId = action.payload;
    },
    toggleModal: (state) => {
      state.isModalOpen = !state.isModalOpen;
    },
  },
});

export const { setFilters, setSelectedBookingId, toggleModal } = bookingSlice.actions;
export default bookingSlice.reducer;
